<template>
    <div>
        <multiselect
            :placeholder="$t('select')"
            v-model="selected"
            :options="options"
            :class="validateError ? 'box-border-color' : ''"
            @input="handleInput($event, multiple)"
            label="text"
            track-by="value"
            :multiple="multiple"
            :select-label="''"
            :selected-label="''"
            :deselect-label="''"
            :searchable="true"
            :disabled="disabled">
            <template slot="selection" slot-scope="{ values, search, isOpen }">
                <span class="multiselect__single" v-if="values.length && !isOpen">
                    {{ translateNSelected(values) }}
                </span>
            </template>
            <span slot="noOptions">
                {{ $t('no_options') }}
            </span>
            <span slot="noResult">
                {{ $t('no_result') }}
            </span>
        </multiselect>
        <span class="invalid-feedback-custom"
              v-show="validateError"
              v-html="validateError">
        </span>
    </div>
</template>

<script>
    import translateNSelected from "@/helpers/translateNSelected";
    import handleInput from "@/helpers/handleInput";
    import setSelected from "@/helpers/setSelected";
    import CoopCompanyService from "@/services/CoopCompanyService";

    export default {
        name: 'CoopCompanySelectbox',
        props: {
            value: {
                default: null
            },
            multiple: {
                type: Boolean,
                default: false
            },
            validateError: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value: function (newValue) {
                this.selected = this.setSelected(newValue, this.options, this.multiple);
            }
        },
        data() {
            return {
                selected: null,
                options: []
            };
        },
        created() {
            this.getOptions();
        },
        methods: {
            handleInput: handleInput,
            setSelected: setSelected,
            translateNSelected: translateNSelected,
            getOptions() {
                const config = {
                    params: {
                        limit: -1,
                        filter: {}
                    }
                };
                this.options = [];
                CoopCompanyService.getAll(config)
                    .then(response => {
                        const items = response.data?.data || response.data || [];
                        items.forEach(item => {
                            this.options.push({
                                value: item.id,
                                text: item.name
                            });
                        });
                    })
                    .then(() => {
                        this.selected = this.setSelected(this.value, this.options, this.multiple);
                    });
            }
        }
    };
</script>
